import { ColumnDef } from "@tanstack/react-table";

import { HalfDay } from "./schema";
import { DataTableColumnHeader } from "./data-table-column-header";

import { Checkbox } from "@/components/ui/checkbox/checkbox";
import { UpdateRowModal } from "./update-row-modal";

const days: {
  [key: number]: string;
} = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
};

export const columns: ColumnDef<HalfDay>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && "indeterminate")
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
        className="translate-y-[2px]"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
        className="translate-y-[2px]"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "dayOfWeek",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Day of Week" />
    ),
    cell: ({ row }) => <div>{days[row.getValue("dayOfWeek") as number]}</div>,
    enableColumnFilter: true,
  },
  {
    accessorKey: "minimumHours",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Minimum Hours" />
    ),
    cell: ({ row }) => <div>{row.getValue("minimumHours")}</div>,
  },
  {
    id: "actions",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Actions" />
    ),
    cell: ({ row, table }) => <UpdateRowModal row={row} table={table} />,
  },
];
